"use client"

import { Modal, Box, Typography, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import styles from "./EventModal.module.css"

export default function EventModal({ open, event, description, onClose }) {
  if (!event) return null

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="event-modal-title"
      aria-describedby="event-modal-description"
    >
      <Box className={styles.modalBox}>
        <IconButton
          onClick={onClose}
          className={styles.closeButton}
        >
          <CloseIcon />
        </IconButton>

        <Typography id="event-modal-title" variant="h5" className={styles.title} gutterBottom>
          {event.title}
        </Typography>
        <Typography id="event-modal-date" variant="subtitle1" color="primary" className={styles.date} gutterBottom>
          {event.date}
        </Typography>
        <Typography id="event-modal-description" className={styles.description}>
          {description}
        </Typography>
      </Box>
    </Modal>
  )
}
